import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const HeroSection = () => {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setPulse((p) => !p), 2000);
    return () => clearInterval(t);
  }, []);

  return (
  <section className="pt-16" style={{ background: 'linear-gradient(135deg, #f0faf4 0%, #e8f5ee 40%, #f5fbf7 100%)' }}>
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="flex flex-col lg:flex-row items-center gap-0 min-h-[420px] md:min-h-[480px]">

        {/* Left: Text Content */}
        <div className="w-full lg:w-1/2 py-10 lg:py-16 pr-0 lg:pr-12">

          {/* Badges row */}
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <div className="inline-flex items-center gap-2 bg-[#E8F5EE] text-[#1B6B3A] text-xs font-bold px-3 py-1.5 rounded-full">
              <i className="ri-map-pin-2-fill text-sm"></i>
              Proudly Serving Los Angeles Since 2010
            </div>
            <a
              href="https://maps.app.goo.gl/1GFb4ZnoPCREHhzy6"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-1.5 bg-white/80 border border-[#c8e6d4] hover:border-[#1B6B3A] text-gray-700 text-xs font-bold px-3 py-1.5 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-star-fill text-yellow-400 text-sm"></i>
              4.8 Google Rating
            </a>
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
            A Better Way<br />
            <span className="text-[#1B6B3A]">to Recycle</span>
          </h1>
          <p className="text-gray-500 text-base leading-relaxed mb-1 font-medium">
            Los Angeles&apos; Trusted Local E-Waste Partner —
          </p>
          <p className="text-gray-500 text-base leading-relaxed mb-6">
            Giving Back to the Communities We Serve Across LA County
          </p>

          <div className="flex flex-wrap gap-3 mb-8">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#1B6B3A] hover:bg-[#2D8653] text-white font-semibold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-arrow-right-circle-line"></i>
              Request Service
            </Link>
            <a
              href="tel:+12136001000"
              className="inline-flex items-center gap-2 border border-gray-300 hover:border-[#1B6B3A] text-gray-700 hover:text-[#1B6B3A] font-semibold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-phone-line"></i>
              (213) 600-1000
            </a>
          </div>

          {/* Stats row */}
          <div className="flex flex-wrap gap-5 pt-6 border-t border-[#c8e6d4]/60">
            {[
              { value: 'Business', icon: 'ri-building-line' },
              { value: 'Commercial', icon: 'ri-store-line' },
              { value: 'Residential', icon: 'ri-home-line' },
            ].map((s) => (
              <div key={s.value} className="flex items-center gap-2 text-sm text-gray-600">
                <div className="w-7 h-7 flex items-center justify-center bg-[#E8F5EE] rounded-full">
                  <i className={`${s.icon} text-[#1B6B3A] text-xs`}></i>
                </div>
                {s.value}
              </div>
            ))}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <div className="w-7 h-7 flex items-center justify-center bg-[#E8F5EE] rounded-full">
                <i className="ri-map-pin-line text-[#1B6B3A] text-xs"></i>
              </div>
              LA County Wide
            </div>

            {/* Battery Recycling pill */}
            <Link
              to="/battery-recycling"
              className="flex items-center gap-2 text-sm font-semibold text-amber-700 bg-amber-50 border border-amber-200 hover:border-amber-400 hover:bg-amber-100 px-3 py-1 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`ri-battery-charge-line text-amber-500 text-sm ${pulse ? 'opacity-100' : 'opacity-60'} transition-opacity duration-700`}></i>
              </div>
              Battery Recycling
              <i className="ri-arrow-right-s-line text-amber-400 text-xs"></i>
            </Link>
          </div>
        </div>

        {/* Right: Truck Image */}
        <div className="w-full lg:w-1/2 h-[280px] md:h-[380px] lg:h-[480px] relative overflow-hidden rounded-lg lg:rounded-none lg:rounded-l-2xl">
          <img
            src="/images/greenlyelectronicsrecycling.png"
            alt="Greenly Electronics Recycling truck serving Los Angeles e-waste pickup"
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
          {/* Overlay tag */}
          <div className="absolute top-4 right-4 bg-[#1B6B3A] text-white text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5">
            <i className="ri-award-line"></i>
            CalRecycle Certified CEWD-127531
          </div>
        </div>

      </div>
    </div>
  </section>
  );
};

export default HeroSection;